@if (isOpen) {
  <div
    class="modal-backdrop"
    role="button"
    tabindex="0"
    (click)="closeModal()"
    (keydown.enter)="closeModal()"
    (keydown.space)="closeModal()"
  >
    <div
      class="modal-container"
      role="dialog"
      aria-modal="true"
      tabindex="0"
      (click)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      (keydown.space)="$event.stopPropagation()"
    >
      <div class="modal-header">
        <h2>Regions Supported</h2>
        <button class="close-btn" (click)="closeModal()">&times;</button>
      </div>

      <div class="modal-body">
        <div class="tabs-container">
          @for (tab of getTabs(); track tab.id) {
            <button
              class="tab-btn"
              [class.active]="activeTab === tab.id"
              (click)="setActiveTab(tab.id)"
            >
              {{ tab.label }} ({{ tab.count }})
            </button>
          }
        </div>

        @if (shouldShowSearch()) {
          <div class="search-container">
            <input
              type="text"
              placeholder="Search..."
              [(ngModel)]="searchQuery"
              class="search-input"
            />
          </div>
        }

        <div class="items-list">
          @for (item of getFilteredItems(); track item) {
            <div class="item-row">{{ item }}</div>
          } @empty {
            <div class="empty-state">No matching regions found.</div>
          }
        </div>
      </div>
    </div>
  </div>
}
